"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15,9.9H19.66a.73.73,0,1,0,0-1.45H7.15a.73.73,0,1,0,0,1.45Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "3.45",
    cy: "14.01",
    rx: "0.74",
    ry: "0.73",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "3.45",
    cy: "18.84",
    rx: "0.74",
    ry: "0.73",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.41,24a.6.6,0,0,0,.22,0,.6.6,0,0,1-.22,0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.83,23a.58.58,0,0,1,.13.19.58.58,0,0,0-.13-.19l-.14-.13h0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15,5.07H19.66a.73.73,0,1,0,0-1.45H7.15a.73.73,0,1,0,0,1.45Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.15,14.74h1a.73.73,0,1,0,0-1.45h-1a.73.73,0,1,0,0,1.45Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "3.45",
    cy: "9.19",
    rx: "0.74",
    ry: "0.73",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "3.45",
    cy: "4.36",
    rx: "0.74",
    ry: "0.73",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.64,18.13H7.15a.73.73,0,1,0,0,1.45H8.64a.73.73,0,1,0,0-1.45Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.26,18.94a3.84,3.84,0,0,1-.84-1.22A3.84,3.84,0,0,0,13.26,18.94Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,21.23a5.06,5.06,0,0,0,.88-.08,5.06,5.06,0,0,1-.88.08Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,20.07h0a4,4,0,0,1-.79-.08A4,4,0,0,0,16,20.07Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.54,14.51a3.85,3.85,0,0,1,.72-1A3.85,3.85,0,0,0,12.54,14.51Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,11.23h0a5.25,5.25,0,0,1,1,.1A5.25,5.25,0,0,0,16,11.23Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,12.39a4,4,0,0,0-.79.08,4,4,0,0,1,.79-.08Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.2,20.13a5.21,5.21,0,0,1-2.28,1A5.21,5.21,0,0,0,19.2,20.13Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.5,18.64a5.23,5.23,0,0,1-.47.68l3.65,3.56h0L20,19.31A5.22,5.22,0,0,0,20.5,18.64Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,22.46a6.32,6.32,0,0,1-6.39-6.23,6.39,6.39,0,0,1,12.77,0,6,6,0,0,1-.76,2.92l2.12,2.07V.71A.64.64,0,0,0,23.05,0H.73A.64.64,0,0,0,0,.71V22.49a.64.64,0,0,0,.73.71H20.56L19,21.72A6.35,6.35,0,0,1,16,22.46ZM7.15,3.62H19.66a.73.73,0,1,1,0,1.45H7.15a.73.73,0,1,1,0-1.45Zm0,4.84H19.66a.73.73,0,1,1,0,1.45H7.15a.73.73,0,1,1,0-1.45Zm0,4.84h1a.73.73,0,1,1,0,1.45h-1a.73.73,0,1,1,0-1.45Zm-3.7,6.28a.73.73,0,1,1,.74-.73A.73.73,0,0,1,3.45,19.57Zm0-4.83A.73.73,0,1,1,4.2,14,.73.73,0,0,1,3.45,14.74Zm0-4.83a.73.73,0,1,1,.74-.73A.73.73,0,0,1,3.45,9.91Zm0-4.83a.73.73,0,1,1,.74-.73A.73.73,0,0,1,3.45,5.09ZM8.64,19.58H7.15a.73.73,0,1,1,0-1.45H8.64a.73.73,0,1,1,0,1.45Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.69,22.88a.64.64,0,0,1-.64.33h-.71l.64.62a.6.6,0,0,0,.84,0A.57.57,0,0,0,24,23.2a.58.58,0,0,0-.13-.19Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.69,22.88,20,19.31a5.23,5.23,0,0,0,.47-.68,4.78,4.78,0,0,0,.65-2.41,5,5,0,0,0-4.09-4.89,5.25,5.25,0,0,0-3,.29,5.13,5.13,0,0,0-2.25,1.81,4.89,4.89,0,0,0,0,5.58A5.13,5.13,0,0,0,14,20.83a5.2,5.2,0,0,0,2,.39,5.06,5.06,0,0,0,.88-.08,5.21,5.21,0,0,0,2.28-1l3.15,3.07h.71A.64.64,0,0,0,23.69,22.88ZM16.83,20a4,4,0,0,1-.79.08h0a4,4,0,0,1-.79-.08,4,4,0,0,1-2-1,3.84,3.84,0,0,1-.84-1.22,3.67,3.67,0,0,1,.13-3.21,3.85,3.85,0,0,1,.72-1,4,4,0,0,1,2-1,4,4,0,0,1,.79-.08h0a4,4,0,0,1,.79.08,4,4,0,0,1,2.47,1.61A3.75,3.75,0,0,1,20,16.23,3.87,3.87,0,0,1,16.83,20Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.41,24h0a.6.6,0,0,1-.22,0A.6.6,0,0,0,23.41,24Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,23.42a.57.57,0,0,1-.17.41A.57.57,0,0,0,24,23.42Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,12.39h0a4,4,0,0,1,.79.08A4,4,0,0,0,16,12.39Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,16.23a3.75,3.75,0,0,0-.67-2.14A3.75,3.75,0,0,1,20,16.23Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,11.23a5.2,5.2,0,0,0-2,.39,5.2,5.2,0,0,1,2-.39Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.11,16.23a3.71,3.71,0,0,1,.44-1.72A3.71,3.71,0,0,0,12.11,16.23Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,20.07a4,4,0,0,0,.79-.08,4,4,0,0,1-.79.08Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,21.23h0a5.2,5.2,0,0,1-2-.39A5.2,5.2,0,0,0,16,21.23Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.79,19A4.91,4.91,0,0,1,11,17.24,4.91,4.91,0,0,0,11.79,19Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,15.22a4.91,4.91,0,0,1,.77-1.79A4.91,4.91,0,0,0,11,15.22Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.31,14.3a.51.51,0,0,1-.27-.08,2.15,2.15,0,0,0-1.62-.1.5.5,0,0,1-.64-.28.48.48,0,0,1,.29-.62,3.14,3.14,0,0,1,2.51.19.48.48,0,0,1,.15.67A.5.5,0,0,1,17.31,14.3Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;